
import { HistoryManager } from "../history";

export function withHistory(editor) {
  editor.history = new HistoryManager(editor);

  // Khởi tạo snapshot ban đầu
  const initialSnapshot = editor.createSnapshot();

  editor.history.init(initialSnapshot);
  editor.history.push(initialSnapshot);

  const originalUpdate = editor.update.bind(editor);

  editor.update = (fn) => {
    originalUpdate(fn);
    editor.history.scheduleSnapshot();
  };

  return editor;
}
